module.exports = __webpack_public_path__ + "static/img/testwd.195d530.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testwd.jpeg
// module id = CZiR
// module chunks = 0